import { IntlShape } from 'react-intl';
import { WIRPhaseTypes } from 'types/wellGuardian';

import { PhaseMessages } from '../wir.constants';

const phaseMessages: PhaseMessages = {
  [WIRPhaseTypes.STAGE_GATE_1]: 'wellGuardian.wir.wirCreation.stageGate1',
  [WIRPhaseTypes.STAGE_GATE_2]: 'wellGuardian.wir.wirCreation.stageGate2',
  [WIRPhaseTypes.STAGE_GATE_3]: 'wellGuardian.wir.wirCreation.stageGate3',
  [WIRPhaseTypes.STAGE_GATE_4]: 'wellGuardian.wir.wirCreation.stageGate4',
  [WIRPhaseTypes.STAGE_GATE_5]: 'wellGuardian.wir.wirCreation.stageGate5',
  [WIRPhaseTypes.INTERVENTION_COMPLETE]:
    'wellGuardian.wir.wirCreation.interventionCompletePhaseLabel',
  [WIRPhaseTypes.REACTIVE_SCOPE]: 'wellGuardian.wir.wirCreation.reactiveScopeLabel',
  [WIRPhaseTypes.ENGINEERING_WORK]: 'wellGuardian.wir.wirCreation.engineeringWorkPhaseLabel',
  [WIRPhaseTypes.CG_ENGINEERING_WORK]: 'wellGuardian.wir.wirCreation.engineeringWorkPhaseLabel',
  [WIRPhaseTypes.KICK_OFF_TECHNICAL_WIR]: 'wellGuardian.wir.wirCreation.komTechnicalWirPhaseLabel',
  [WIRPhaseTypes.CG_KICK_OFF_TECHNICAL_WIR]:
    'wellGuardian.wir.wirCreation.komTechnicalWirPhaseLabel',
  [WIRPhaseTypes.WIR_CREATED]: 'wellGuardian.wir.wirCreation.wirCratedPhaseLabel',
  [WIRPhaseTypes.CG_WIR_CREATED]: 'wellGuardian.wir.wirCreation.wirCratedPhaseLabel',
  [WIRPhaseTypes.FINAL_WIR]: 'wellGuardian.wir.wirCreation.finalWirPhaseLabel',
  [WIRPhaseTypes.CG_FINAL_WIR]: 'wellGuardian.wir.wirCreation.finalWirPhaseLabel',
  [WIRPhaseTypes.FINAL_PREPARATION]: 'wellGuardian.wir.wirCreation.finalPreparationPhaseLabel',
  [WIRPhaseTypes.NG_FINAL_PREPARATION]: 'wellGuardian.wir.wirCreation.finalPreparationPhaseLabel',
  [WIRPhaseTypes.CG_FINAL_PREPARATION]: 'wellGuardian.wir.wirCreation.finalPreparationPhaseLabel',
  [WIRPhaseTypes.INTERVENTION_CLOSE_OUT]:
    'wellGuardian.wir.wirCreation.interventionCloseoutPhaseLabel',
  [WIRPhaseTypes.NG_INTERVENTION_CLOSE_OUT]:
    'wellGuardian.wir.wirCreation.interventionCloseoutPhaseLabel',
  [WIRPhaseTypes.CG_INTERVENTION_CLOSE_OUT]:
    'wellGuardian.wir.wirCreation.interventionCloseoutPhaseLabel',
  [WIRPhaseTypes.INTERVENTION_OPERATION]:
    'wellGuardian.wir.wirCreation.interventionOperationPhaseLabel',
  [WIRPhaseTypes.NG_INTERVENTION_OPERATION]:
    'wellGuardian.wir.wirCreation.interventionOperationPhaseLabel',
  [WIRPhaseTypes.CG_INTERVENTION_OPERATION]:
    'wellGuardian.wir.wirCreation.interventionOperationPhaseLabel',
};

export const getPhaseState = (intl: IntlShape, countryState: string, state?: string) => {
  if (state) {
    const messageId = phaseMessages[state];

    return intl.formatMessage({
      id: messageId,
    });
  }
};
